import React, { useState } from 'react';
import styles from '../../loginPage.module.css';
// import components from '../../../../resources/styles/components.module.css';
import { IAM_PATH } from '../../../../utils/Config';
import axios from '../../../../utils/api/axios'; 
import { InnocodeButton, InnocodeInput, InnocodeTextButton, useDialog } from '@intsoft/innocode-core';

function LinkAccountLoginPanel({ socialData, onLinkSuccess, onSignup }) { 

  const [inputs, setInputs] = useState({
    id: '',
    password: '',
  });
  const [feedback, setFeedback] = useState('');

  const onChange = (e) => {
    const { value, name } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLinkAccount = async () => {
    if (!inputs.id || !inputs.password) {
      setFeedback('이메일과 비밀번호를 모두 입력해주세요.');
      return;
    }

    try {
      // 1. 기존 계정 존재 여부 확인
      const existRes = await axios.post(`${IAM_PATH}/exist`, { unifiedProfileId: inputs.id });
      if (!existRes.data.data) {
        setFeedback('회원정보가 없는 계정입니다. 회원가입을 진행해 주세요.');
        return;
      }
      
      // 2. 소셜 계정 연동 업데이트
      const updateRes = await axios.post(`${IAM_PATH}/update/linkedacounts`, {
        unifiedProfileId: inputs.id,
        linkedAcounts: {
          [socialData.provider]: {
            provider: socialData.provider,
            oauth_id: socialData.auth_id,
            email: socialData.email,
            connected_at: new Date().toISOString()
          }
        }
      });

      if (updateRes.data.code === 200) {
        onLinkSuccess();
      } else {
        setFeedback(updateRes.data.resultMessage || '계정 연동에 실패했습니다.');
      }
    } catch (err) {
      console.error('계정 연동 오류:', err);
      setFeedback('계정 연동 중 오류가 발생했습니다.');
    }
  };

  return (
    <>
      <div className={styles.content_section}>
        <div className={styles.login_section_inner}>
          <div className={styles.login_title}>간편 로그인 연동</div>
          <div className={styles.login_form_group}>
            <div className={styles.login_form_row}>
              <div className={styles.login_form_label_row}>
                <div className={styles.login_form_label}>Email</div>
              </div>
              <InnocodeInput  
                type="email"
                name="id"
                placeholder="아이디"
                value={inputs.id}
                onChange={onChange}
              />
              {/* <div className={styles.input_container}>
                <input
                  className={`${components.innocode_input} ${components.innocode_input_md}`}
                  type="email"
                  name="id"
                  placeholder="example@email.com"
                  value={inputs.id}
                  onChange={onChange}
                />
              </div> */}
            </div>
            <div className={styles.login_form_row}>
              <div className={styles.login_form_label_row}>
                <div className={styles.login_form_label}>Password</div>
              </div>
              <InnocodeInput
                type="password"
                name="password"
                placeholder="********"
                value={inputs.password}
                onChange={onChange}
              />
              {/* <div className={styles.input_container}>
                <input
                  className={`${components.innocode_input} ${components.innocode_input_md}`}
                  type="password"
                  name="password"
                  placeholder="********"
                  value={inputs.password}
                  onChange={onChange}
                />
              </div> */}
            </div>
            {feedback && <p className={styles.feedback_text}>{feedback}</p>}
          </div>
          <div className={styles.login_submit_btn_container}>
            <InnocodeButton size="lg" onClick={handleLinkAccount} designType={'primary'} theme={'solid'} className={styles.login_submit_btn}>연동 하기</InnocodeButton>
            {/* <button
              type="button"
              className={`${components.btn} ${components.btn_solid} ${components.btn_primary} ${components.btn_lg} ${styles.login_submit_btn}`}
              onClick={handleLinkAccount}
            >
              <span className={components.btn__text}>연동 하기</span>
            </button> */}
          </div>
          <div className={styles.divider}></div>
          <div className={styles.login_link_group}>
            <div className={styles.login_link_row}>
                {/* <div className={styles.login_link_btn}>
                    <a href="#" className={`${components.link_btn} ${components.link_btn_assistive}`}>
                        ID 찾기
                    </a>
                </div> */}
                <InnocodeTextButton type={'assistive'} onClick={() => {window.location.href = `${IAM_PATH}/findid`}}>ID 찾기</InnocodeTextButton>
                <InnocodeTextButton type={'assistive'} onClick={() => {window.location.href = `${IAM_PATH}/findpw`}}>비밀번호 찾기</InnocodeTextButton>
            </div>
            <div className={styles.login_link_btn}>
              <span className={`innocode-typography--body-sm-reading innocode-typography--regular ${styles.link_btn_assistive}`}>아직 회원이 아니신가요?</span>
              <InnocodeTextButton type={'primary'} onClick={onSignup}>
                회원가입
              </InnocodeTextButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LinkAccountLoginPanel;
